import { MonthlyResultsPage } from 'components/SimulationGroup/MonthlyResults/MonthlyResultsPage';
import React, { PureComponent, ReactNode } from 'react';

import { IProps } from './MonthlyResultsMono.container';

export class MonthlyResultsMono extends PureComponent<IProps> {
  public render(): ReactNode {
    const { routeMonoSimulationGroup } = this.props;

    return <MonthlyResultsPage routeSimulationGroup={routeMonoSimulationGroup} />;
  }
}
